import { CustomSection, CustomSectionName } from '@wix/add-panel-common';
import type { FC } from 'react';
import type { CustomSectionWithSection } from './CustomSection.types';
import {
  BlankSection,
  ElementsRegistryDev,
  MobileTools,
  MyDesigns,
  MyWidgets,
  SiteSearch,
  VeloDevMode,
} from './customSections';

export const getCustomSectionComponent = ({ sectionName }: CustomSection): FC<CustomSectionWithSection> | null => {
  switch (sectionName) {
    case CustomSectionName.MyDesigns:
      return MyDesigns;
    case CustomSectionName.MyWidgets:
      return MyWidgets;
    case CustomSectionName.SiteSearch:
      return SiteSearch;
    case CustomSectionName.VeloDevMode:
      return VeloDevMode;
    case CustomSectionName.MobileTools:
      return MobileTools;
    case CustomSectionName.ElementsRegistryDev:
      return ElementsRegistryDev;
    case CustomSectionName.BlankSection:
      return BlankSection;
    default:
      return null;
  }
};

export const hasCustomSectionComponent = (section: CustomSection): boolean =>
  Boolean(getCustomSectionComponent(section));
